import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../components/TemplateDashboard";
import IncidenciasContent from './components/IncidenciasContent';

const IncidenciasListado = () => {

    return (
        <>

            <TemplateDashboard>
                <IncidenciasContent />
            </TemplateDashboard>

        </>
    )
};

export default IncidenciasListado;